import Utility from '@sparta.sales.utilities/module-utils-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"cta-mortgage-overview-module-wrapper\">\n    <div class=\"row headline-row\">\n        <div class=\"column small-12 small-centered\">\n            <h2>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"headline") || (depth0 != null ? lookupProperty(depth0,"headline") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headline","hash":{},"data":data,"loc":{"start":{"line":5,"column":16},"end":{"line":5,"column":30}}}) : helper))) != null ? stack1 : "")
    + "</h2>\n        </div>\n    </div>\n    <div class=\"row buttons-group\">\n        <div class=\"column small-12\">\n            <div class=\"row show-for-small-only buttons-row\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"buttons") : depth0)) != null ? lookupProperty(stack1,"small") : stack1)) != null ? lookupProperty(stack1,"access") : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":12,"column":16},"end":{"line":25,"column":23}}})) != null ? stack1 : "")
    + "                </div>\n\n                <div class=\"or-line column\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"separatorText") : depth0),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":18},"end":{"line":32,"column":25}}})) != null ? stack1 : "")
    + "                  <div class=\"cnx-regular center\">\n                      <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"separatorText") || (depth0 != null ? lookupProperty(depth0,"separatorText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"separatorText","hash":{},"data":data,"loc":{"start":{"line":34,"column":25},"end":{"line":34,"column":44}}}) : helper))) != null ? stack1 : "")
    + "</p>\n                  </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"separatorText") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":36,"column":18},"end":{"line":39,"column":25}}})) != null ? stack1 : "")
    + "                </div>\n\n            </div>\n            <div class=\"row show-for-medium-up buttons-row\">\n                <div class=\"center-buttons\">\n                    <div class=\"wrapper\">\n                      <div class=\"buttons-wrapper\">\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"buttons") : depth0)) != null ? lookupProperty(stack1,"large") : stack1),{"name":"with","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":47,"column":24},"end":{"line":59,"column":33}}})) != null ? stack1 : "")
    + "                        </div>\n                        <div class=\"or-line\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"separatorText") : depth0),{"name":"if","hash":{},"fn":container.program(17, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":62,"column":26},"end":{"line":65,"column":33}}})) != null ? stack1 : "")
    + "                          <div class=\"cnx-regular center\">\n                              <p>"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"separatorText") || (depth0 != null ? lookupProperty(depth0,"separatorText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"separatorText","hash":{},"data":data,"loc":{"start":{"line":67,"column":33},"end":{"line":67,"column":52}}}) : helper))) != null ? stack1 : "")
    + "</p>\n                          </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"separatorText") : depth0),{"name":"if","hash":{},"fn":container.program(19, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":69,"column":26},"end":{"line":72,"column":33}}})) != null ? stack1 : "")
    + "                        </div>\n                    <div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\"row contact-us-row show-for-small-only\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"contactTextSmall") : depth0),{"name":"if","hash":{},"fn":container.program(21, data, 0),"inverse":container.program(23, data, 0),"data":data,"loc":{"start":{"line":81,"column":6},"end":{"line":86,"column":13}}})) != null ? stack1 : "")
    + "    </div>\n    <div class=\"row contact-us-row show-for-medium-up\">\n      <p class=\"cnx-regular\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"contactText") || (depth0 != null ? lookupProperty(depth0,"contactText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contactText","hash":{},"data":data,"loc":{"start":{"line":89,"column":29},"end":{"line":89,"column":46}}}) : helper))) != null ? stack1 : "")
    + "</p>\n    </div>\n</section>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"wrapper row center-buttons\">\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"buttons") : depth0)) != null ? lookupProperty(stack1,"small") : stack1),{"name":"with","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":18},"end":{"line":16,"column":27}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"access") || (depth0 != null ? lookupProperty(depth0,"access") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"access","hash":{},"data":data,"loc":{"start":{"line":15,"column":20},"end":{"line":15,"column":32}}}) : helper))) != null ? stack1 : "")
    + "\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <div class=\"wrapper row buttons-row\">\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"buttons") : depth0)) != null ? lookupProperty(stack1,"small") : stack1),{"name":"with","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":20,"column":18},"end":{"line":23,"column":27}}})) != null ? stack1 : "")
    + "\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <div class=\"column small-6 left-column\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"apply") || (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"apply","hash":{},"data":data,"loc":{"start":{"line":21,"column":60},"end":{"line":21,"column":71}}}) : helper))) != null ? stack1 : "")
    + "</div>\n                    <div class=\"column small-6 right-column\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"learnMore") || (depth0 != null ? lookupProperty(depth0,"learnMore") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":22,"column":61},"end":{"line":22,"column":76}}}) : helper))) != null ? stack1 : "")
    + "</div>\n";
},"8":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"left\"><hr>\n                    </div>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "                    <div class=\"right\"><hr>\n                    </div>\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"access") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":49,"column":26},"end":{"line":58,"column":33}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            <div class=\"center\">\n                              "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"access") || (depth0 != null ? lookupProperty(depth0,"access") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"access","hash":{},"data":data,"loc":{"start":{"line":51,"column":30},"end":{"line":51,"column":42}}}) : helper))) != null ? stack1 : "")
    + "\n                            </div>\n";
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"apply") || (depth0 != null ? lookupProperty(depth0,"apply") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"apply","hash":{},"data":data,"loc":{"start":{"line":55,"column":28},"end":{"line":55,"column":39}}}) : helper))) != null ? stack1 : "")
    + "\n                            <span class=\"spacer\"></span>\n                            "
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"learnMore") || (depth0 != null ? lookupProperty(depth0,"learnMore") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"learnMore","hash":{},"data":data,"loc":{"start":{"line":57,"column":28},"end":{"line":57,"column":43}}}) : helper))) != null ? stack1 : "")
    + "\n";
},"17":function(container,depth0,helpers,partials,data) {
    return "                            <div class=\"left\"><hr>\n                            </div>\n";
},"19":function(container,depth0,helpers,partials,data) {
    return "                            <div class=\"right\"><hr>\n                            </div>\n";
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"cnx-regular\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"contactTextSmall") || (depth0 != null ? lookupProperty(depth0,"contactTextSmall") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contactTextSmall","hash":{},"data":data,"loc":{"start":{"line":82,"column":31},"end":{"line":82,"column":53}}}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"cnx-regular\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"contactText") || (depth0 != null ? lookupProperty(depth0,"contactText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"contactText","hash":{},"data":data,"loc":{"start":{"line":85,"column":31},"end":{"line":85,"column":48}}}) : helper))) != null ? stack1 : "")
    + "</p>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"local") : depth0)) != null ? lookupProperty(stack1,"content") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":92,"column":9}}})) != null ? stack1 : "");
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.home-loans.modules/cta-mortgage-overview-module",
  "version": "2.0.0",
  "id": "ctaMortgageOverviewModule",
  "containerID": "homeLoansCtaMortgageOverviewModule",
  "moduleName": "home-loans-cta-mortgage-overview-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "cta-mortgage-overview-module",
  "data": {
    "init": "ctaMortgageOverviewModule",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.sales.utilities/module-utils-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/**
 * @export
 * @class ctaMortgageOverviewModule
 * @extends {Module}
 */
class ctaMortgageOverviewModule extends Module {
  /**
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.$target = $('#ctaMortgageOverviewModule');

    // bind this method
    this.bindAllMethod = Utility.bindAllMethod.bind(this);

    // then bind all methods
    this.bindAllMethod();
  }

  /**
   * @return {void}
   */
  init() {}
}
registerModuleClass({
  moduleClass: ctaMortgageOverviewModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ctaMortgageOverviewModule as default, moduleConfig };
